import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AdminDashboard } from '@/components/admin/admin-dashboard';
import { ArrowLeft } from 'lucide-react';

export function AdminPage() {
  return (
    <div className="w-full">
      <div className="mb-4">
        <Button asChild variant="outline" className="gap-2">
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </Button>
      </div>
      <AdminDashboard />
    </div>
  );
}